<template>
  <v-card
    :height="`${canvasHeight || 500}px`"
    style="overflow-y: scroll;"
  >
    <div
      class="white"
      style="position: sticky; top: 0px; z-index: 2;"
    >
      <v-card class="d-flex justify-space-between elevation-0">
        <v-btn
          v-if="showChangeFloatingBoxPosition || showChangeShape && !disabled"
          icon
          @click="() => {
            showChangeFloatingBoxPosition = false
            showChangeShape = false
          }"
        >
          <v-icon class="black--text">
            mdi-arrow-left
          </v-icon>
        </v-btn>
        <v-btn
          v-else
          icon
          @click="$emit('click:close')"
        >
          <v-icon class="black--text">
            mdi-close
          </v-icon>
        </v-btn>
        <slot name="title">
          <div class="font-weight-bold align-self-center">
            {{ value.text || value.tableName || '' }}
          </div>
        </slot>
        <v-btn
          icon
          :disabled="disabled"
          @click="$emit('click:flip')"
        >
          <v-icon class="transparent--text">
            mdi-horizontal-rotate-counterclockwise
          </v-icon>
        </v-btn>
      </v-card>
      <v-divider />
    </div>
    <v-tabs
      :value="selectedTab"
      height="0"
    >
      <v-tab key="config" />
      <v-tab key="shape" />
      <v-tab key="floating-box" />
      <v-tab-item key="config">
        <v-container>
          <v-row no-gutters>
            <v-col
              cols="12"
              :md="hideChangeShape ? 12 : 6"
              class="px-3 pt-3"
            >
              <slot name="element-text-field">
                <v-text-field
                  v-model="value.text"
                  label="Label"
                  :disabled="disabled"
                  clearable
                />
              </slot>
            </v-col>
            <v-col
              v-if="!hideChangeShape"
              align-self="center"
              cols="12"
              md="6"
              class="px-3 pt-3"
            >
              <v-btn
                block
                @click="showChangeShape = true"
              >
                Change Shape
              </v-btn>
            </v-col>
          </v-row>
          <v-row 
            v-if="!hideChangeFloatingBoxPosition"
            no-gutters
          >
            <v-col
              cols="12"
              class="px-3"
            >
              <v-btn
                block
                @click="showChangeFloatingBoxPosition = true"
              >
                Change Floating Box Position
              </v-btn>
            </v-col>
          </v-row>
          <slot />
          <!-- <div class="d-flex justify-space-around">
            <v-switch 
              v-model="value.showOnFloorPlan"
              label="Show on Floor Plan"
            />
            <v-boolean 
              v-model="value.disabled"
              label="Enabled"
              invert
            />
          </div> -->
          <v-row no-gutters>
            <v-col
              cols="12"
              sm="6"
              class="px-3 pt-3"
            >
              <v-btn
                block
                @click="$emit('click:duplicate', value)"
              >
                Duplicate
              </v-btn>
            </v-col>
            <v-col
              cols="12"
              sm="6"
              class="px-3 pt-3"
            >
              <v-btn
                block
                @click="$emit('click:delete', value)"
              >
                Delete
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-tab-item>
      <v-tab-item key="shape">
        <v-container>
          <slot name="shape">
            <v-card class="elevation-0 text-center font-weight-bold">
              No Shapes Available...
            </v-card>
          </slot>
        </v-container>
      </v-tab-item>
      <v-tab-item key="floating-box">
        <v-container>
          <slot name="floating-box">
            <v-card class="elevation-0 text-center font-weight-bold">
              No Floating Box Positions Available...
            </v-card>
          </slot>
        </v-container>
      </v-tab-item>
    </v-tabs>
  </v-card>
</template>

<script>
export default {
  name: 'SelectedElement',
  props: {
    value: Object,
    disabled: Boolean,
    disableBack: Boolean,
    hideChangeShape: Boolean,
    hideChangeFloatingBoxPosition: Boolean,
    canvasHeight: {
      type: Number,
      default: 500
    }
  },
  data () {
    return {
      showChangeShape: false,
      showChangeFloatingBoxPosition: false,
    }
  },
  computed: {
    selectedTab: {
      get () {
        if (this.showChangeShape) return 1
        else if (this.showChangeFloatingBoxPosition) return 2
        return 0
      },
      set (newVal) {
        this.showChangeShape = false, this.showChangeFloatingBoxPosition = false
        switch (newVal) {
        case 1:
          this.showChangeShape = true
          break
        case 2: 
          this.showChangeFloatingBoxPosition = true
          break
        }
      }
    },
  },
  watch: {
    'value.shape' () {this.selectedTab = 0},
    'value.floatingBoxPosition' () {this.selectedTab = 0},
    'value.icon' () {this.selectedTab = 0},
  }
}
</script>